<template>
  <el-dialog
    v-model="modalVisible"
    :title="title"
    style="width: 30%"
    center
    @close="
      emit('close-modal');
      emit('update:modelValue', false);
    "
  >
    <div class="dialog-content">
      <div class="select-container">
        <custom-select
          v-model="tipoProductoSeleccionado"
          :settings="{
            placeholder: 'Seleccionar tipo de producto',
            options: elementosGrupo,
          }"
          :loading="isLoading"
        ></custom-select>
      </div>
      <div>
        <el-button
          type="primary"
          :disabled="!tipoProductoSeleccionado.Codigo"
          size="default"
          @click="create"
          >{{ title }}</el-button
        >
      </div>
    </div>
  </el-dialog>
</template>

<script setup>
import {
  onBeforeMount,
  onMounted,
  ref,
  watch,
} from 'vue';
import { useRouter } from 'vue-router';
import { storeToRefs } from 'pinia';
import CustomSelect from '@/shared/components/custom_select.vue';
import { useElementoGrupoStore } from '@/stores/elemento_grupo/elemento_grupo_store';
import elemento_grupo_model from '@/shared/models/elemento_grupo_model.js';

const router = useRouter();
const elementoGrupoStore = useElementoGrupoStore();
const { elementosGrupo } = storeToRefs(elementoGrupoStore);

const modalVisible = ref(false);
const tipoProductoSeleccionado = ref({ ...elemento_grupo_model });
const isLoading = ref(false);

const props = defineProps({
  title: { type: String, default: 'Crear nuevo elemento' },
  url: { type: String },
  modelValue: { type: Boolean, default: false },
});

const emit = defineEmits(['close-modal', 'update:modelValue']);

// Sincronizar la prop modelValue con modalVisible
watch(
  () => props.modelValue,
  (newValue) => {
    modalVisible.value = newValue;
  },
);

// Cargar datos cada vez que se abre el modal
watch(modalVisible, async (isVisible) => {
  if (isVisible) {
    console.log('Modal opened - loading data');
    isLoading.value = true;
    elementoGrupoStore.emptyList();
    await elementoGrupoStore.findAllElementosGrupoHTTP({ page: 0, Activo: true });
    // Resetear la selección cuando se abre el modal
    tipoProductoSeleccionado.value = { ...elemento_grupo_model };
    isLoading.value = false;
  }
});

const create = () => {
  localStorage.setItem('tipoProductoSeleccionado', JSON.stringify(tipoProductoSeleccionado.value));
  elementoGrupoStore.selectElementoGrupo(tipoProductoSeleccionado.value.Codigo);
  if (props.url) {
    router.push(props.url);
  }
  emit('close-modal');
  emit('update:modelValue', false);
};

onBeforeMount(() => {
  console.log('Modal select product type before mount');
});

onMounted(async () => {
  console.log('Modal select product type mounted');
  // Cargar datos iniciales solo si el modal está visible al montarse
  if (props.modelValue) {
    elementoGrupoStore.emptyList();
    await elementoGrupoStore.findAllElementosGrupoHTTP({ page: 0, Activo: true });
  }
});
</script>

<style scoped>
.dialog-content {
  display: flex;
  justify-content: center;
  align-items: end;
}

.select-container {
  flex: 1;
  margin-right: 20px;
}
</style>
